<template>
    <el-dialog
        :title="(isForm ? (modId ? '编辑' : '添加模块') : '查看') + dialogTitle"
        width="640px"
        :model-value="modelValue"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" style="max-width: 540px">
            <el-form-item label="标识ID" prop="id">
                <el-input v-if="isForm" v-model="formData.id" :readonly="!!modId"></el-input>
                <span v-else>{{ formData.id }}</span>
            </el-form-item>
            <el-form-item label="模块名称" prop="name">
                <el-input v-if="isForm" v-model="formData.name"></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="链接地址" prop="url">
                <el-input v-if="isForm" v-model="formData.url"></el-input>
                <span v-else>{{ formData.url }}</span>
            </el-form-item>
            <el-form-item label="模块简介">
                <el-input v-if="isForm" v-model="formData.intro" type="textarea"></el-input>
                <div v-else>{{ formData.intro }}</div>
            </el-form-item>
            <el-form-item label="模块状态">
                <el-radio-group v-if="isForm" v-model="formData.status" :disabled="formData.id == 'base'">
                    <el-radio :value="1">正常</el-radio>
                    <el-radio :value="0">停用</el-radio>
                </el-radio-group>
                <div v-else>{{ formData.status ? '正常' : '停用' }}</div>
            </el-form-item>
            <el-form-item label="是否显示">
                <el-radio-group v-if="isForm" v-model="formData.visible" :disabled="formData.id == 'base'">
                    <el-radio :value="1">显示</el-radio>
                    <el-radio :value="0">隐藏</el-radio>
                </el-radio-group>
                <div v-else>{{ formData.status ? '显示' : '隐藏' }}</div>
            </el-form-item>
            <el-form-item label="排序值">
                <el-input-number
                    v-if="isForm"
                    v-model="formData.list_order"
                    class="mx-4"
                    :min="0"
                    :max="999999"
                    controls-position="right"
                />
                <span v-else>{{ formData.list_order }}</span>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { addModule, getModuleDetail, putModule } from '@/api/module.js'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    modId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    id: '',
    name: '',
    url: '',
    intro: '',
    list_order: 0,
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    id: [
        {
            required: true,
            trigger: 'blur',
            message: '标识ID不能为空！'
        }
    ],
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '模块名称不能为空！'
        }
    ],
    url: [
        {
            required: true,
            trigger: 'blur',
            message: '链接地址不能为空！'
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)
/**
 * 关闭
 */
const closed = () => {
    dialogTitle.value = ''
    emits('update:modelValue', false)
    formRef.value.resetFields()
}

/**
  确定按钮点击事件
 */

const onConfirm = async () => {
    if (!props.isForm) return
    if (props.modId !== '') {
        await doPutModule()
    } else {
        await doAddModule()
    }
}

// 修改模块
const doPutModule = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        console.log(formData.value, 'formData')
        if (!valid) return
        submitLoading.value = true
        try {
            await putModule(formData.value)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 添加模块
const doAddModule = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            await addModule(formData.value)
            // 模块添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch (error) {
            submitLoading.value = false
        }
    })
}

// 获取模块详情
const getModuleDetailFun = async () => {
    formData.value = await getModuleDetail(props.modId)
    dialogTitle.value = name
}

// 只有modId有的时候，才会去请求数据
watch(
    () => props.modId,
    (newVal) => {
        if (newVal) {
            getModuleDetailFun()
        } else {
            formData.value = {
                id: '',
                name: '',
                url: '',
                intro: '',
                list_order: 0,
                status: 1,
                visible: 1
            }
        }
    }
)
</script>

<style lang="scss" scoped></style>
